<template lang="pug">
form.navbar-form.navbar-right(role='search')
  ed-input.search-box(v-model='searchText'
                :placeholder='$t("Search")'
                search
                )
</template>
<script>
export default {
  name: 'navbar-search',
  data() {
    return {
      searchText: ''
    }
  }
}
</script>

<style lang='scss'>
@import "~@/assets/sass/_variables.scss";

.theme.skin .navbar-form .form-group.search-box .form-control[search] {
  padding-bottom: 0.1em;

  &+.search-icon {
    color: $canvas;
  }
}

</style>



// WEBPACK FOOTER //
// navbar-search.vue?4a88d9b8